var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-row-component', _vm.isLast ? 'last-row' : '']},[_c('div',{staticClass:"label"},[_vm._t("label")],2),_c('div',{staticClass:"form-content"},[_vm._t("form-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }